/** The `key` argument SSOT for `extractStringInput` (`@federa/utils/validation/extract-string-field`) call sites.
 *
 * ONE leaf for the whole family, folded 2026-08-24 out of three single-const leaves that carried one member each under
 * three unrelated names, so the question "does a key for this field already exist?" had three places to look and an
 * author adding a fourth key had no reason to find any of them. The two loser leaves were named for a CONSUMER (a
 * subsystem, a service) rather than for the decision they carried, which is what let the split read as intentional.
 * Members are consumer-agnostic by construction: a key is the field NAME on an untyped ingress record, and the same
 * field read from two subsystems is one decision -- so a new key belongs HERE regardless of which tier reads it.
 *
 * GROUPED, and the flat spelling this leaf briefly carried was WRONG. The fold's first draft kept three flat
 * `EXTRACT_STRING_INPUT_*` exports and declined grouping, citing the `mechanical-foreclosures` row about a
 * `GROUP.MEMBER` path resolving to no body. That citation was over-generalized and the decline is RETRACTED: the row
 * is scoped to flow `inputSchema` / `outputSchema` resolution, where a single-capture resolver walks one member level
 * to find a braced schema body. These are plain string keys, never resolved as a schema, so the mechanism cannot
 * reach them -- exactly the "a mechanism claim is a hypothesis until someone opens the leaf" trap that skill's
 * `SKILL.md` names. The flat draft was caught by replaying all 1,438 registered rules against this
 * file before landing: `QUAL-CONST-GROUP-001` convicted it, because three flat exports sharing the three-segment
 * leading run `EXTRACT_STRING_INPUT` with non-empty tails is precisely its class, and its key-collision arm confirms
 * no other `const/` leaf exports this group. That rule derives its own exemption set from live matcher needles, so
 * its firing is also the authoritative answer that grouping this key blinds nothing. */

/** Field NAMES on untyped ingress records, passed as the `key` argument to `extractStringInput`. */
export const EXTRACT_STRING_INPUT = {
	/** Desk / redaction ingress record. */
	AUTH_TOKEN: 'auth_token',
	/** Storage-gateway durable-object bid websocket payload. */
	BID_ID: 'bidId',
	/** Storage-gateway durable-object websocket frame envelope -- the tag that selects the domain handler. */
	DATA_TYPE: 'dataType',
	/** Kaizen promote-verifier input record; every consumer defaults to `process.cwd()`. */
	REPO_ROOT: 'repoRoot',
	/** Storage-gateway durable-object websocket payload. */
	WS_ERROR: 'wsError',
} as const;
